import { useNavigate } from 'react-router-dom';
import { StatusModal } from '../../components/Modal/Payment';

const FailedPayment = () => {
  const navigate = useNavigate();

  return (
    <div className='main_page'>
      <StatusModal
        title='Payment failed'
        subtitle='We apologize, but it seems that your payment was unsuccessful.'
        description='Please review your details and try again later.'
        icon='icon-paper-fail'
        iconColor='var(--red-600)'
        buttonText='Ok'
        onSubmit={() => navigate('/')}
      />
    </div>
  );
};

export default FailedPayment;
